export const AddressesComponent = {
    template: `
        <oo-card id="ca-customer-addresses">
            <oo-card-header>
                <p>Delivery Addresses</p>
            </oo-card-header>

            <oo-card-body>
                <address-pane
                    ng-repeat="address in $ctrl.accountService.data.addresses"
                    ng-if="!$ctrl.loading && ($ctrl.isNoAddressInEditState() || $ctrl.isEditing[$index])"
                    is-editing="$ctrl.isEditing[$index]"
                    address="address"
                ></address-pane>

                <div class="oo-edit-state fold-animation">
                    <button
                        ng-if="!$ctrl.loading && $ctrl.isNoAddressInEditState()"
                        type="button"
                        class="button disclaimer button-link"
                        ng-click="$ctrl.addingAddress = true"
                        ga-track-event="$ctrl.addAddressEvent"
                    >Add Address</button>

                    <form name="$ctrl.editForm" ng-if="$ctrl.addingAddress" ng-submit="$ctrl.onSubmit()">
                        <add-address address="$ctrl.address" save="enabled"></add-address>

                        <div ng-if="!$ctrl.isValid && !$ctrl.editForm.$pristine">
                            <address-suggestions
                                current-address="$ctrl.address"
                                error="$ctrl.errors"
                                on-address-selection="$ctrl.setSuggestedAddress(address)">
                            </address-suggestions>
                        </div>

                        <div class="flex-row centered-row">
                            <button
                                class="button button-inline button-secondary button-inline_quarter"
                                type="button"
                                ng-click="$ctrl.resetForm()"
                                >Cancel</button>
                            <oo-button
                                class="button-inline button-inline_quarter"
                                types="button-primary"
                                button-type="submit"
                                is-disabled="$ctrl.editForm.$invalid"
                                is-loading="$ctrl.isLoading";
                                >Save</oo-button>
                        </div>
                    </form>
                </div>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(accountService, $q, addressService, googleAnalyticsTrackingService) {
            'ngInject';
            this.accountService = accountService;
            this.$q = $q;
            this.addressService = addressService;
            this.loading = true;
            this.isEditing = {};
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
            this.addAddressEvent = googleAnalyticsTrackingService.getAddAddressEvent();
        }

        $onInit() {
            this.resetForm();
            this.accountService.getAddresses()
                .then(() => this.addingAddress = !this.accountService.data.addresses.length)
                .finally(() => this.loading = false);
        }

        isNoAddressInEditState() {
            for (var address in this.isEditing) {
                if (this.isEditing[address]) return false;
            }
            return !this.addingAddress;
        }

        resetForm() {
            this.address = {
                address1: null,
                address2: null,
                city: null,
                latitude: null,
                longitude: null,
                name: null,
                notes: null,
                state: null,
                zipCode: null
            };
            this.errors = {};
            this.addingAddress = false;
        }

        onSubmit() {
            this.isLoading = true;
            return this.addressService.validate(this.address)
                .then(address => this._saveAddress(address))
                .then(
                    address => this._onSuccess(address),
                    err => this._onError(err)
                )
                .finally(() => this.isLoading = false);
        }

        _saveAddress(address) {
            const permanent = true;
            return this.addressService.geocodeAddress(address, permanent)
                .then(
                    addr => this.accountService.addAddress(addr),
                    error => this.$q.reject(error)
                );
        }

        _onSuccess() {
            this.googleAnalyticsTrackingService.trackAddress('success');

            this.isValid = true;
            this.resetForm();
        }

        _onError(err) {
            this.googleAnalyticsTrackingService.trackAddress('error');

            this.errors = err;
            this.isValid = false;
        }

        setSuggestedAddress(address) {
            this.address = address;
            this.errors = {};
        }
    }
};
